<template>
    <div style="height: 100%; padding-bottom: 18px">
        <div class="sa-accordion-wrapper">
            <form>
                <div class="sa-accordion">
                    <input class="sa-accordion-input" type="radio" name="prescrizione-radio-a" id="prescrizione-farmaco-radio-a" value="1" checked="checked" />
                    <label class="sa-accordion-label" for="prescrizione-farmaco-radio-a">
                        Farmaci
                        <b-button size="sm" variant="outline-success outline-secondary-noborder pull-right sa-accordion-btn" @click="onClickNuovaPrescrizioneFarmacologica()">
                            <i class="fas fa-plus"></i>
                            Prescrivi Farmaco
                        </b-button>
                    </label>
                    <div class="sa-accordion-content">
                        <div class="b-table-sticky-header">
                            <b-table sticky-header ref="table" stacked="lg" striped hover :items="prescrizioniFarmacologiche" :fields="fieldsPrescrizioniFarmacologiche" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                                <template v-slot:cell(orari)="{ item }">
                                    <span>{{ getPianificazione(item) }}</span>
                                </template>
                                <template v-slot:cell(note)="{ item }">
                                    <span v-html="item.note"></span>
                                </template>
                                <template v-slot:cell(actions)="row">
                                    <b-container class="bv-example-row">
                                        <b-button v-b-tooltip.hover size="sm" variant="outline-primary no-text" title="Modifica Pianificazione" @click="onClickEditPrescrizioneFarmacologica(row.item, row.index, $event.target)" class="mr-1 no-text">
                                            <b-icon icon="pencil"></b-icon>
                                        </b-button>
                                    </b-container>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </div>
                <div class="sa-accordion">
                    <input class="sa-accordion-input" type="radio" name="prescrizione-radio-a" id="prescrizione-prestazione-radio-a" value="2" />
                    <label class="sa-accordion-label" for="prescrizione-prestazione-radio-a">
                        Prestazioni
                        <b-button size="sm" variant="outline-success outline-secondary-noborder pull-right sa-accordion-btn" @click="onClickNuovaPrescrizionePrestazione()">
                            <i class="fas fa-plus"></i>
                            Prescrivi Prestazione
                        </b-button>
                    </label>
                    <div class="sa-accordion-content">
                        <div class="b-table-sticky-header">
                            <b-table sticky-header ref="table" stacked="lg" striped hover :items="prescrizioniPrestazioni" :fields="fieldsPrescrizioniPrestazioni" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                                <template v-slot:cell(note)="{ item }">
                                    <span v-html="item.note"></span>
                                </template>
                                <template v-slot:cell(actions)="row">
                                    <b-container class="bv-example-row">
                                        <b-button v-b-tooltip.hover size="sm" variant="outline-primary no-text" title="Modifica Pianificazione" @click="onClickEditPrescrizionePrestazioni(row.item, row.index, $event.target)" class="mr-1 no-text">
                                            <b-icon icon="pencil"></b-icon>
                                        </b-button>
                                    </b-container>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <sa-modal-loading ref="saModalLoading" />
        <rsa-paziente-prescrizione-farmaco-edit-modal-component ref="mdlRsaPazientePrescrizioneFarmacoEditModalComponent" @afterSave="onAfterSaveRsaPazientePrescrizioneFarmacoEditModalComponent"></rsa-paziente-prescrizione-farmaco-edit-modal-component>
        <rsa-aree-pianificazione-edit-component ref="cmpRsaAreePianificazioneEditComponent" @afterSaveRequest="onAfterSaveRequestRsaAreePianificazioneComponent"></rsa-aree-pianificazione-edit-component>
        <prescrizione-farmaco-component ref="mdlPrescrizioneFarmacoComponent" @afterSava="onAfterSaveMdlPrescrizioneFarmacoComponent"></prescrizione-farmaco-component>
        <prescrizione-specialistica-component ref="mdlPrescrizioneSpecialisticaComponent" @afterSava="onAfterSaveMdlPrescrizioneSpecialisticaComponent"></prescrizione-specialistica-component>
    </div>
</template>

<script>
import moment from "moment";
import RsaAreePianificazioneEditComponent from "../RsaAreePianificazioneEditComponent.vue";
import RsaPazientePrescrizioneFarmacoEditModalComponent from "../../../rsapaziente/components/RsaPazientePrescrizioneFarmacoEditModalComponent.vue";
import PrescrizioneFarmacoComponent from "../../../../utility/components/PrescrizioneFarmacoComponent.vue";
import PrescrizioneSpecialisticaComponent from "../../../../utility/components/PrescrizioneSpecialisticaComponent.vue";
import axios from "axios";
import UtilityMixin from "../../../../utility/UtilityMixin";
import { SaModalLoading } from "../../../../../template/components/modal";
export default {
    mixins: [UtilityMixin],
    components: { RsaAreePianificazioneEditComponent, RsaPazientePrescrizioneFarmacoEditModalComponent, PrescrizioneFarmacoComponent, PrescrizioneSpecialisticaComponent, SaModalLoading },
    data() {
        return {
            perPage: 10000,
            pathResourcePazientePrescrizioniFarmacologiche: "/rsapazienteprescrizioni/farmaci",
            //pathResourcesSchedulazioni: "/rsaattivitapazienteschedulazioni",
            pathResourcePazientePrescrizioniPrestazioni: "/rsapazienteprescrizioni/prestazioni",
            pathResourcesAree: "/rsaaree",
            prescrizioniFarmacologiche: [],
            prescrizioniPrestazioni: [],
            jsonDataAccettazione: null,
            area: null,
            fieldsPrescrizioniFarmacologiche: [
                {
                    label: "Nome Farmaco",
                    key: "prescrizione",
                    sortable: true,
                },
                {
                    label: "Q.tà",
                    key: "quantita",
                    thStyle: "width: 5rem",
                    sortable: true,
                },
                {
                    label: "Programmazione",
                    key: "orari",
                    thStyle: "width: 5rem",
                    sortable: true,
                },
                {
                    label: "Posologia",
                    key: "posologia",
                    thStyle: "width: 5rem",
                    sortable: true,
                },
                {
                    label: "Stato",
                    key: "stato",
                    sortable: true,
                    thStyle: "width: 5rem",
                    //tdClass: "text-right",
                },
                {
                    label: "Note",
                    key: "note",
                    sortable: true,
                },
                {
                    label: "Data Inizio",
                    key: "dataInizio",
                    sortable: true,
                    thStyle: "width: 7rem",
                    formatter: (value) => {
                        return moment(value).format("DD-MM-YYYY");
                    },
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
            fieldsPrescrizioniPrestazioni: [
                {
                    label: "Nome Farmaco",
                    key: "prescrizione",
                    sortable: true,
                },
                {
                    label: "Q.tà",
                    key: "quantita",
                    thStyle: "width: 5rem",
                    sortable: true,
                },
                {
                    label: "Orari",
                    key: "frequenza",
                    thStyle: "width: 5rem",
                    sortable: true,
                },
                {
                    label: "Posologia",
                    key: "posologia",
                    thStyle: "width: 5rem",
                    sortable: true,
                },
                {
                    label: "Stato",
                    key: "stato",
                    sortable: true,
                    thStyle: "width: 5rem",
                    //tdClass: "text-right",
                },
                {
                    label: "Note",
                    key: "note",
                    sortable: true,
                },
                {
                    label: "Data Inizio",
                    key: "dataInizio",
                    sortable: true,
                    thStyle: "width: 7rem",
                    formatter: (value) => {
                        return moment(value).format("DD-MM-YYYY");
                    },
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    mounted() {
        this.loadAree();
    },
    methods: {
        loadAree() {
            let me = this;

            let link = process.env.VUE_APP_PATH_API + me.pathResourcesAree + "/codicearea/SMT";
            axios
                .get(link)
                .then((response) => {
                    me.area = response.data.data;
                })
                .catch(() => {});
        },
        loadPrescrizioniPaziente(jsonDataAccettazione) {
            let me = this;
            me.jsonDataAccettazione = jsonDataAccettazione;
            me.loadPrescrizioniFarmacologichePaziente();
            me.loadPrescrizioniPrestazioniPaziente();
        },
        loadPrescrizioniFarmacologichePaziente() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourcePazientePrescrizioniFarmacologiche;
            axios
                .get(link, { params: { idAccettazione: me.jsonDataAccettazione.id } })
                .then((response) => {
                    me.prescrizioniFarmacologiche = [];
                    me.prescrizioniFarmacologiche = response.data.data.list;
                })
                .catch((error) => {
                    UtilityMixin.methods.messaggeBoxError(this, error);
                });
        },
        loadPrescrizioniPrestazioniPaziente() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourcePazientePrescrizioniPrestazioni;
            axios
                .get(link, { params: { idAccettazione: me.jsonDataAccettazione.id } })
                .then((response) => {
                    me.prescrizioniPrestazioni = [];
                    me.prescrizioniPrestazioni = response.data.data.list;
                })
                .catch((error) => {
                    UtilityMixin.methods.messaggeBoxError(this, error);
                });
        },
        onClickNuovaPrescrizioneFarmacologica() {
            let prescrisione = {
                id: null,
                idAccettazione: this.jsonDataAccettazione.id,
                idPaziente: this.jsonDataAccettazione.id,
                dataInizio: new Date().getTime(),
                dataFine: null,
                codiceProdotto: null,
                atcGmp: null,
                prescrizione: null,
                quantita: 0,
                frequenza: null,
                costo: 0,
                stato: null,
                note: null,
                tipoPrestazione: "FARMACOLOGICA",
                params: JSON.stringify({ formaFarmaceutica: null, listaOrari: [] }),
            };
            if (this.jsonDataAccettazione.statoAttuale === "DIMISSIONE" || this.jsonDataAccettazione.statoAttuale === "TRASFERITO" || this.jsonDataAccettazione.statoAttuale === "ASSENTE") {
                let messaggio = this.jsonDataAccettazione.statoAttuale === "DIMISSIONE" || this.jsonDataAccettazione.statoAttuale === "TRASFERITO" ? "Non è possibile questa operazione su un paziente dimesso" : "Non è possibile questa operazione su un paziente assente";
                this.$bvModal.msgBoxOk(messaggio, {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                });
                return;
            } else {
                this.$refs.mdlRsaPazientePrescrizioneFarmacoEditModalComponent.show(this.jsonDataAccettazione, prescrisione);
            }
        },
        onClickEditPrescrizioneFarmacologica(item) {
            this.$refs.mdlRsaPazientePrescrizioneFarmacoEditModalComponent.show(this.jsonDataAccettazione, item);
        },
        onClickNuovaPrescrizionePrestazione() {
            let me = this;
            if (me.jsonDataAccettazione.statoAttuale === "DIMISSIONE" || me.jsonDataAccettazione.statoAttuale === "TRASFERITO" || me.jsonDataAccettazione.statoAttuale === "ASSENTE") {
                let messaggio = me.jsonDataAccettazione.statoAttuale === "DIMISSIONE" || me.jsonDataAccettazione.statoAttuale === "TRASFERITO" ? "Non è possibile questa operazione su un paziente dimesso" : "Non è possibile questa operazione su un paziente assente";
                this.$bvModal.msgBoxOk(messaggio, {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                });
                return;
            } else {
                me.$refs.mdlPrescrizioneSpecialisticaComponent.show(me.jsonDataAccettazione);
            }
        },
        onClickEditPrescrizionePrestazioni(item) {
            let me = this;
            me.$refs.mdlPrescrizioneSpecialisticaComponent.edit(me.jsonDataAccettazione, item);
        },
        onAfterSaveMdlPrescrizioneFarmacoComponent() {
            let me = this;
            me.loadPrescrizioniFarmacologichePaziente();
        },
        onAfterSaveMdlPrescrizioneSpecialisticaComponent() {
            let me = this;
            me.loadPrescrizioniPrestazioniPaziente();
        },
        onAfterSaveRequestRsaAreePianificazioneComponent() {},
        getPianificazione(item) {
            let params = JSON.parse(item.params);
            let returnValue = "";
            let giorni = [];
            if (params.listaOrari.length > 0) {
                let detaglio = params.listaOrari[0];
                switch (detaglio.tipo) {
                    case "TURNI":
                        for (let giorno of detaglio.giorni.split(",")) {
                            let dayOfWeek = this.getDayOfWeek(giorno);
                            giorni.push(dayOfWeek);
                        }
                        break;
                    case "ORARIO":
                        for (let giorno of detaglio.giorni.split(",")) {
                            let dayOfWeek = this.getDayOfWeek(giorno);
                            giorni.push(dayOfWeek);
                        }
                        break;
                    case "ORE ALTERNATE":
                        for (let giorno of detaglio.giorni.split(",")) {
                            let dayOfWeek = this.getDayOfWeek(giorno);
                            giorni.push(dayOfWeek);
                        }
                        break;
                    case "GIORNI ALTERNATI":
                        giorni.push("Ogni " + detaglio.giorni + " giorno/i");
                        break;
                    case "GIORNI MESE":
                        giorni.push("Nei giorni " + detaglio.giorni + " del mese");
                        break;
                }
            }
            returnValue = giorni.join(", ");
            return returnValue;
        },
        onAfterSaveRsaPazientePrescrizioneFarmacoEditModalComponent() {
            let me = this;
            me.loadPrescrizioniFarmacologichePaziente();
        },
    },
};
</script>

<style></style>
